import { useQuery } from '@apollo/client';
import { GET_MEMBERSHIP_DETAILS_FROM_LEAGUE } from '../../graphql';

const useVoloPassPrice = ({ programId }: { programId: string }) => {
  const {
    data: leagueData,
    error: leagueError,
    loading: leagueLoading,
  } = useQuery(GET_MEMBERSHIP_DETAILS_FROM_LEAGUE, {
    fetchPolicy: 'cache-and-network',
    skip: !programId,
    variables: { leagueId: programId },
  });

  const { voloPassTiers, voloFitnessTiers } = leagueData?.league?.organization || {};

  const { isActive: isVoloPassActive = false } = voloPassTiers || {};
  const { isActive: isVoloFitnessActive = false } = voloFitnessTiers || {};

  return {
    isVoloPassActive,
    isVoloFitnessActive,
    error: leagueError,
    loading: leagueLoading,
  };
};

export default useVoloPassPrice;
